<template>
  <tender-form-label :key="index"
    :label="options.Name"
    :prop="options.Key"
    :rules="rules"
    class="form-select-checkbox"
    show-msg
  >
    <el-checkbox-group v-model="form[options.Key]" @change="selectChangeHandle">
      <template v-if="isFunctionOptions">
        <el-checkbox v-for="(obj, i) in checkboxOptions" :key="i"
          v-show="!obj.Hidden"
          :label="obj.Name"
          :disabled="obj.Disabled"
        ></el-checkbox>
      </template>
      <template v-else>
        <el-checkbox v-for="(obj, i) in options.Options" :key="i"
          v-show="!obj.Hidden"
          :label="obj.Name"
          :disabled="obj.Disabled"
        ></el-checkbox>
      </template>
    </el-checkbox-group>
  </tender-form-label>
</template>
<script>
import { mixForFormItem } from "../../../js/mixins"
import utils from '../../../js/utils'
import tenderHook from "../../../js/hooks"
export default {
  name: 'FormSelectCheckbox',
  mixins: [mixForFormItem],
  created() {
    this.setDefaultValue()
  },
  computed: {
    isFunctionOptions() {
      return typeof this.options.Options === 'function'
    },
    checkboxOptions() {
      let { Options } = this.options
      if(this.isFunctionOptions) {
        return Options(this.form)
      }
      return Options
    }
  },
  methods: {
    setDefaultValue() {
      let {form = {}, options = {}} = this
      utils.readyToSetFormItemDefault(form, options).then(() => {
        options.Init && options.Init(form, true)
        this.setFormItemValue(options.Value || [])
      }).catch(() => null)
    },
    selectChangeHandle(value) {
      this.$nextTick(() => {
        // this.doValidate()
        this.doSelectEvent()
      })
    },
    doSelectEvent(isOnlySet) {
      let { options = {} } = this;
      let { Refs = [] } = options;
      Refs.forEach((eRef) => {
        let [type] = eRef;
        switch (type) {
          case "trafficHooks":
            tenderHook.refEvent(isOnlySet, this)
            break;
        }
      });
      
      this.doValidate()
    }
  }
}
</script>
<style lang="scss">
.form-select-checkbox {
  padding: 0;
  margin: 0 !important;
  .el-checkbox {
    height: 25px;
    --el-disabled-text-color: black;
    --el-checkbox-disabled-checked-icon-color: black;
    --el-checkbox-disabled-checked-input-border-color: black;
  }
  .el-checkbox__inner {
    border-color: black;
  }
  .el-checkbox__label {
    color: black;
    font-size: auto;
  }
  .el-checkbox-group {
    position: relative;
    z-index: 1;
    padding: 2px 8px;
  }
  &.tender-form-label.el-form-item--default,
  &.tender-form-label.el-form-item {
    .el-form-item__content {
      display: block;
    }      
  }
  &.is-error {
    .el-form-item__error {
      top: 0;
      bottom: 0;
      right: 0;
      padding: 7px;
      text-align: right;
      color: #efdede;
      background: #efdede;
      border-bottom: 1px solid red;
    }
  }
}
</style>